// 执行元素定位
export const elePosition = (param) => {
  // beHavior 参数：smooth滚动有过渡性，平滑的形式，auto没有过渡性的效果
  const {
    eleById,
    beHavior = "smooth",
    block = "center",
    inline = "center",
    eleType = "id", // id 或者 error
  } = param
  if (eleType === "error") {
    const container = document.querySelector(".Polaris-Scrollable")
    if (container) {
      setTimeout(() => {
        // 获取第一个具有报错元素位置
        const eleByClass = container.querySelector(".Polaris-InlineError__Icon")

        if (eleByClass) {
          // 滚动容器到该元素的位置
          eleByClass.scrollIntoView({
            behavior: beHavior,
            block, // 将元素的上边沿对齐容器的上边缘
            inline, // 将元素滚动到最接近的位置
          })
        } else {
          console.log("not find element")
        }
      }, 500)
    }
    return
  }
  const nodeEle = document.getElementById(eleById)
  if (nodeEle) {
    nodeEle.scrollIntoView({
      behavior: beHavior, // 或 "smooth" 以进行平滑滚动
      block, // 将元素的上边沿对齐容器的上边缘
      inline, // 将元素滚动到最接近的位置
    })
  }
}

// 计算元素相对于容器的偏移量
const getOffsetTop = (element, container) => {
  let offsetTop = 0
  while (element && element !== container) {
    offsetTop += element.offsetTop
    element = element.offsetParent
  }
  return offsetTop
}

const calcSmoothScroll = (container, targetScrollTop) => {
  const start = container.scrollTop
  const distance = targetScrollTop - start
  const duration = 400 // 400ms 滚动时间
  let startTime = 0

  const step = (timestamp) => {
    if (!startTime) startTime = timestamp
    const progress = timestamp - startTime
    const easeInOut =
      progress / duration < 0.5
        ? 2 * (progress / duration) ** 2
        : 1 - Math.pow(-2 * (progress / duration) + 2, 2) / 2

    container.scrollTop = start + distance * easeInOut

    if (progress < duration) {
      requestAnimationFrame(step)
    } else {
      container.scrollTop = targetScrollTop // 确保滚动到最终位置
    }
  }

  requestAnimationFrame(step)
}

export const handleSmoothScroll = ({ container, targetEle }) => {
  const _container = document.querySelector(`.${container}`)

  if (_container) {
    setTimeout(() => {
      // 获取第一个具有报错元素位置
      const _targetEle = _container.querySelector(`.${targetEle}`)

      if (_targetEle) {
        const offsetTop = getOffsetTop(_targetEle, _container)

        // 滚动容器到该元素的位置
        calcSmoothScroll(_container, offsetTop - 80)
      } else {
        console.log("Element not found.")
      }
    }, 500)
  } else {
    console.log("Element not found.")
  }
}
